module.exports = __webpack_public_path__ + "media/images/icon__point--white@3x-99365fc169fb6d89d761ad5982676d5e.png";